import * as e from "react";
import { forwardRef as o } from "react";
const i = o(function(r, t) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...r
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M10.197 16.0495L15.597 11.9995L10.197 7.94946V16.0495Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12 3C7.02751 3 3 7.02751 3 12C3 16.9724 7.02751 21 12 21C16.9724 21 21 16.9725 21 12C21 7.02747 16.9725 3 12 3ZM12 19.2C8.03098 19.2 4.79997 15.969 4.79997 12C4.79997 8.03098 8.03098 4.80001 12 4.80001C15.969 4.80001 19.2 8.03098 19.2 12C19.2 15.969 15.969 19.2 12 19.2Z",
        fill: "currentColor"
      }
    )
  );
});
export {
  i as LiveStreaming
};
